<template lang="pug">
#transaction-history.tab-pane.fade.show.active
  .statement-wrapper
    .statement-mobile
      .statement-single
        template(v-if="transactionHistory.length > 0")
          .statement-single-content(v-for="(ticket, index) in transactionHistory")
            .statement-date {{ticket.request_type}}
            //- .statement-date(v-if="ticket.deposit_date") {{$moment(ticket.deposit_date).format("YYYY-MM-DD HH:mm:ss")}} {{ticket.request_type}}
            //- .statement-date(v-else) {{$moment(ticket.created_date).format("YYYY-MM-DD HH:mm:ss")}}
            .statement-detail
              .statement-detail-left {{$t('ui.date')}}
              .statement-detail-right(v-if="ticket.deposit_date") {{$moment(ticket.deposit_date).format("YYYY-MM-DD HH:mm:ss")}} {{ticket.request_type}}
              .statement-detail-right(v-else) {{$moment(ticket.created_date).format("YYYY-MM-DD HH:mm:ss")}}
            .statement-detail
              .statement-detail-left {{$t('ui.method')}}
              .statement-detail-right {{ticket.target_bank_id}}({{ticket.deposit_method}})
            .statement-detail
              .statement-detail-left {{$t('ui.amount')}}
              .statement-detail-right(v-if="ticket.deposit_method==='USDT'") {{ticket.amount}}
                span.text-warning ({{ ticket.exchanged_amount }} USDT)
              .statement-detail-right(v-else) {{ticket.amount}}
            .statement-detail
              .statement-detail-left {{$t('ui.status')}}
              .statement-detail-right(:class="getColor(ticket.status, ticket.request_type)") {{getStatus(ticket.status, ticket.request_type)}} 
        template(v-else)
          .text-center.py-2 {{ $t('ui.no_record') }}!
    .statement-desktop
      .table-responsive
        table.table-history
          tr
            th {{$t('ui.no')}}
            th {{$t('ui.date')}}
            th {{$t('ui.type')}}
            th {{$t('ui.method')}}
            th {{$t('ui.bank')}}
            th {{$t('ui.amount')}}
            th {{$t('ui.status')}}
            th {{$t('ui.eta')}}
          template(v-if="transactionHistory.length > 0")
            tr(v-for="(ticket, index) in transactionHistory")
              td {{index+1}}
              td {{$moment(ticket.created_date).format("YYYY-MM-DD HH:mm:ss")}}
              td {{ticket.request_type}}
              td(v-if="ticket.deposit_method != null ") {{ticket.deposit_method}}
              td(v-else) -
              td {{ticket.target_bank_id}}
              td(v-if="ticket.deposit_method==='USDT'") {{ticket.amount}} 
                span.text-warning ({{ ticket.exchanged_amount }} USDT)
              td(v-else) {{ticket.amount}}
              td(:class="getColor(ticket.status, ticket.request_type)") {{getStatus(ticket.status, ticket.request_type)}} 
              td {{$moment(ticket.created_date).add(5, "m").format("YYYY-MM-DD HH:mm:ss")}}
          template(v-else)
            tr
              td(colspan="8")
                .text-center.py-2 {{ $t('ui.no_record') }}!
</template>
<script>
export default {
  data() {
    return {
      // lastUpdateTime: new Date(),
      transactionHistory: [],
      refreshTicket: null
    };
  },
  computed: {
    accountID() {
      return this.$store.getters.accountID
    },
    sessionToken() {
      return this.$store.getters.sessionToken
    },
  },
  mounted(){
    window.scroll(0,0)
    var vm = this
    this.getMemberTicketList()
    this.refreshTicket = setInterval(() => {
      vm.getMemberTicketList()
    }, 10000)
  },
  beforeDestroy: function() {
    clearInterval(this.refreshTicket)
  },
  methods:{
    clearIntervalLoop(){
      clearInterval(this.refreshTicket);
    },
    getStatus(status, request) {
      var tag = "ui.unknown";
      switch(status) {
        case "REJECTED":
          tag = "ui.failed";
          break;
        case "pending":
          tag = "ui.pending";
          break;
        case "PROCESSED":
          tag = "ui.approved";
          break;
      }
      if(status==="PROCESSING"){
        return this.$t('ui.pending') + "(" + this.$t('ui.payment_gateway') + ")"
      }else{
        return this.$t(tag);
      }
      
    },
    getColor(status, request) {
      var tag = "";
      switch(status) {
        case "REJECTED":
          tag = "text-danger";
          break;
        case "pending":
        case "PROCESSING":
          tag = "text-warning";
          break;
        case "PROCESSED":
          tag = "text-success";
          break;
      }
      return tag;
    },
    getMemberTicketList() {
      if (this.sessionToken) {
        // this.lastUpdateTime = new Date()
        let account_id = this.accountID
        let auth_token = this.sessionToken
        this.$store
          .dispatch("user/getMemberTicketList", { account_id, auth_token })
          .then(response => {
            if (response.success == true) {
              this.transactionHistory = response.data;
              this.$emit("updateTrans", this.transactionHistory.length)
            } else {
              if((typeof response.status) != 'object'){
                this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
              }      
            }
          })
          .catch(response => {
            if((typeof response.status) != 'object'){
              this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
            }else{
              if(response.status.status == 0){
                this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list.disconnect"), "info", this);
                this.$router.push("/").catch(error =>{})
              }
            }
            $('body').removeClass('modal-open');
            $('.modal-backdrop').remove();
          });
      }
    }
  }
}
</script>